import React from 'react';
import _ from 'lodash';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { format } from '../../../../common/services/common.service';

export const SubscriptionContainer = ({ selectedVenture }: any) => {
    return (
        <>
            <AccordionContainer
                child={
                    <div className="h-auto w-full bg-white p-2 rounded overflow-y-auto">
                        <table className="w-full text-xs bg-red-50">
                            <thead className="w-full border-y border-black border-opacity-20">
                                <tr className="w-full text-left h-12">
                                    <th className="px-3">S.NO</th>
                                    <th className="px-3">BusinessName</th>
                                    <th className="px-3">Amount</th>
                                    <th className="px-3">Email</th>
                                    <th className="px-3">Phone Number</th>
                                    <th className="px-3">Validity</th>
                                    <th className="px-3">DBA Name</th>
                                     <th className="px-3">Owner Name</th>
                                      <th className="px-3">Owner Type</th>
                                </tr>
                            </thead>
                            <tbody className="w-full h-auto">
                                {selectedVenture?.Subscriptions?.map((Subscription: any, index: any) => (
                                    <tr key={index} className="cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
                                        <td className="px-3">{index + 1}</td>
                                        <td className="px-3">{Subscription?.BusinessName}</td>
                                        <td className="px-3">{Subscription?.Amount}</td>
                                        <td className="px-3">{Subscription?.Email}</td>
                                        <td className="px-3">{Subscription?.PhoneNumber}</td>
                                        <td className="px-3">{Subscription?.Validity}</td>
                                        <td className="px-3">{Subscription?.DBAName}</td>
                                        <td className="px-3">{Subscription?.OwnerName}</td>
                                        <td className="px-3">{Subscription?.OwnerType}</td>
                                        </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }
                expandedPanel="NPSubscription Info"
                headerTitle="NPSubscription Info"

            />

        </>
    )
}
export default SubscriptionContainer;